import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppBaseComponent } from "@utils";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router, UrlTree } from "@angular/router";
import { AuthService, FileService, MessageService, ProcedureService, RegistrationService } from "@services";
import Swal from 'sweetalert2';
import { lastValueFrom, Observable, Subscription } from "rxjs";
import { ROUTES } from "@enums";
import { OnExit } from "../../../../core/guards/pending-changes.guard";


@Component({
  selector: 'app-request-sst',
  templateUrl: './request-sst.component.html',
  styleUrls: ['./request-sst.component.scss']
})
export class RequestSstComponent extends AppBaseComponent implements OnInit, OnDestroy, OnExit {
  //numbers
  step: number = 2;
  currentStep: number = 50;

  //strings
  procedureTitle: string = 'Licencia para prestación de servicios en Seguridad y Salud en el Trabajo';
  procedureDescription: string = `
    Solicitar la expedición, renovación o modificación de la licencia para prestar servicios en Seguridad y Salud en el Trabajo
    como persona natural o jurídica, pública o privada.
  `;
  procedureInitPopUpNatural: string = 'Para su comodidad realice el trámite en el ente territorial donde reside o realizó sus estudios, de lo contrario podrá ser anulado.';
  renewalPopUp: string = 'La licencia que desea renovar debe pertenecer a Bogotá. De lo contrario debe contactar el ente territorial correspondiente.\n' +
    '¿La licencia a renovar pertenece a Bogotá?';
  juridicaPopUp: string = 'El trámite de licencia para persona jurídica debe realizarlo en el ente territorial donde se encuentre el domicilio de la institución, de lo contrario será anulado.\n' +
    '¿El domicilio de la persona jurídica es Bogotá?';


  //Manipulacion DOM
  @ViewChild('radioPrimeraVez') radioPrimeraVez: ElementRef;
  @ViewChild('radioModificacion') radioModificacion: ElementRef;
  @ViewChild('radioRenovacion') radioRenovacion: ElementRef;

  //booleans
  showReqForm: boolean;

  showResumeRequestSaved: boolean = false;
  public showModificationForm: boolean = false;
  public showRenewalForm: boolean = false;
  public ocultarRenovacionBogota: boolean = true;
  public tramiteEnCurso: boolean = false; //todos deshabilitado

  public showFormPersonaJuridica: boolean = false;

  numRadicado: any;

  //forms
  requestForm: FormGroup

  //opt
  procedureTypes: any = [
    { id: 1, name: 'Primera Vez' },
    { id: 2, name: 'Modificación' },
    { id: 3, name: 'Renovación' }
  ];

  subscriptionFileService: Subscription;
  subscriptionLogged: Subscription;
  files: any[] = [];
  logged: boolean = false;
  sending: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private fileService: FileService,
    private procedureService: ProcedureService,
    private authService: AuthService,
    private popupAlert: MessageService,
    private registrationService: RegistrationService) {
    super();
  }

  ngOnInit(): void {

    this.showFormPersonaJuridica = this.authService.getLoggedUser().datosPersonales.personTypeId != 1 && this.authService.getLoggedUser().datosPersonales.razonSocial != null;

    this.subscriptionFileService = this.fileService.getFilesAdded$
      .subscribe(resp => {
        if (resp) this.files = resp;
      });

    this.subscriptionLogged = this.authService.currentUser$
      .subscribe(resp => {
        console.log(resp);
        this.logged = !!resp;
      });

    this.popUpInicioTramiteNatural();

    this.requestForm = this.fb.group(
      {
        // procedureNumber: [ '', [ Validators.minLength(3), Validators.maxLength(30) ] ],
        processId: ['', [Validators.required]],
        // se deben agregar los otros forms (nested forms -> controlContainer class)
        laborForm: this.fb.group(
          {
            companyWorking: ['2'],
            companyName: [''],
            companyAddress: [''],
            companyDepartmentId: [null],
            companyMunicipalityId: [null],
            companyPhone: [''],
            companyCellPhone: ['']
          }
        ),
        typeServiceForm: this.fb.group(
          {
            servicesToProvide: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(100)]],
            basicCharacteristicsServices: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(100)]],
            otherServices: ['', [Validators.maxLength(100)]]
          }
        ),
        attachmentForm: this.fb.group(
          {
            programTypeId: [null, [Validators.required]],
            titleTypeId: [null, [Validators.required]],
            typeProfessionalId: [null, []],
            titleProfessionalName: ['', [Validators.required, Validators.minLength(5)]],
            titleDoctorateName: ['', [Validators.required, Validators.minLength(5)]],
            otherProfessionalName: ['', [Validators.required, Validators.minLength(5)]],
            entityAddress: ['', Validators.minLength(5)],
            quantityDocuments: []
          }
        ),
        //PRESENTE: Las validaciones se realizan en los ultimos metodos
        // ya que que los campos y secciones son dinamicas para estos 2 ultimos forms
        modificationForm: this.fb.group(
          {
            reasonModificationId: [''],
            resolutionToModify: [''],
            dateResolutionToModify: [''],
            file: [''],
            licenciaVigenteFile: [''],
            soporteModificacionFile: [''],
            fileSoporte: ['']
          }
        ),
        renewalForm: this.fb.group(
          {
            renovationDepartmentId: [''],
            renovationMunicipalityId: [''],
            resolutionToModify: [''],
            dateResolutionToModify: [''],
            file: [''],
            licenciaAnteriorFile: ['']
          }
        )
      }
    );

    if (this.showFormPersonaJuridica) {
      setTimeout(() => {
        this.clearValidatorsAttachmentsFrm();
      }, 1000);
      this.requestForm.get('attachmentForm.entityAddress').setValidators([Validators.required, Validators.minLength(5)]);
      this.requestForm.get('attachmentForm.entityAddress').updateValueAndValidity();
    }

    this.requestForm.controls['processId'].valueChanges
      .subscribe(value => {
        if (value) {
          console.log(value);
          switch (value.toString()) {
            case '1':
              this.setOrRemoveValidatorsInModify(0);
              this.setOrRemoveValidatorsInRenew(0);
              break;
            case '2':
              this.setOrRemoveValidatorsInModify(1);
              this.setOrRemoveValidatorsInRenew(0);
              break;
            case '3':
              this.setOrRemoveValidatorsInModify(0);
              this.setOrRemoveValidatorsInRenew(1);
              break;
          }
        }
      });

    this.requestForm.get('laborForm.companyWorking')!.valueChanges
      .subscribe(value => {
        if (value) {
          console.log(value);
          if (value == '2')
          {
            value='0';
          }
          this.setOrRemoveValidatorsIfWorking(Number.parseInt(value))

        }
      });

    this.requestForm.get('attachmentForm.programTypeId')!.valueChanges
      .subscribe(value => {
        this.validacionesCamposPostgradoYTipoProfesional();
      })

    this.requestForm.get('attachmentForm.typeProfessionalId')!.valueChanges
      .subscribe(value => {
        this.validacionesOtroProfesional();
      })
  }

  ngOnDestroy() {
    if (this.subscriptionFileService) {
      this.subscriptionFileService.unsubscribe();
    }

    if (this.subscriptionLogged) {
      this.subscriptionLogged.unsubscribe();
    }

    this.requestForm.reset();
  }

  public popUpInicioTramiteJuridica(): void {
    Swal.fire({
      icon: 'question',
      title: 'Renovación de licencias',
      text: this.juridicaPopUp,
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'NO',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'SI'
    }).then((result) => {
      if (result.isDenied || result.isDismissed) {
        Swal.fire(
          'Renovación de licencias',
          'No es posible continuar con el trámite ya que no pertenece a Bogotá',
          'error'
        );
        this.radioPrimeraVez.nativeElement.disabled = true;
        this.radioModificacion.nativeElement.disabled = true;
        this.radioRenovacion.nativeElement.disabled = true;
        this.ocultarRenovacionBogota = true;
      }
    });
  }

  public popUpInicioTramiteNatural(): void {
    if (!this.logged) {
      this.popupAlert.infoAlert(
        'Respetado(a) Ciudadano(a), recuerde primero iniciar sesión para continuar con esta acción',
        4000);
      return;
    }

    this.showReqForm = true;
    if (this.showFormPersonaJuridica ) {
      this.popUpInicioTramiteJuridica();
    } else {
      Swal.fire({
        icon: 'info',
        title: 'Respetado(a) Ciudadano(a)',
        text: this.procedureInitPopUpNatural,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        showCloseButton: true
      }).then((result) => {
        if (this.tramiteEnCurso) {
          this.radioPrimeraVez.nativeElement.disabled = true;
          this.radioModificacion.nativeElement.disabled = true;
          this.radioRenovacion.nativeElement.disabled = true;
        } else {
          this.radioPrimeraVez.nativeElement.disabled = false;
          this.radioModificacion.nativeElement.disabled = false;
          this.radioRenovacion.nativeElement.disabled = false;
        }
      });
    }
  }

  verifyProcedureOnCourse(): boolean {

    let habilitarBotones = false;

    this.procedureService.getCurrentProcedure().subscribe(resp => {
      let procedure = resp;
      console.log("PROCEDURE ACTUAL");
      console.log(resp);

      //LIsta con los estados id donde puede crear una solicitd
      //firma aprobado o negado director
      //anulacion tramite
      //revocada
      if (procedure.statusId == 6 || procedure.statusId == 10 || procedure.statusId == 12 || procedure.statusId == 13
        || procedure == null) {
        this.tramiteEnCurso = false;
        habilitarBotones = true;
      } else {
        this.tramiteEnCurso = true;
        habilitarBotones = false;
        Swal.fire({
          icon: 'warning',
          title: 'Tramite en curso',
          text: "Respetado(a) Ciudadano(a)... ¡Ya tiene un trámite registrado y está en proceso de validación. Debe esperar a tener respuesta del mismo, consultando el estado de su trámite en la bandeja de trámites!",
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          showCloseButton: true
        });
      }

    })

    return habilitarBotones;
  }

  public changeTypeTramite(field: string): void {
    switch (field) {
      case 'primera':
        this.showModificationForm = false;
        this.showRenewalForm = false;
        this.ocultarRenovacionBogota = false;
        break;
      case 'modificacion':
        this.showModificationForm = true;
        this.showRenewalForm = false;
        this.ocultarRenovacionBogota = false;
        break;
      case 'renovacion':
        this.popUpRenovacionLicencia();
        break;
    }
  }

  public popUpRenovacionLicencia(): void {
    Swal.fire({
      icon: 'question',
      title: 'Renovación de licencias',
      text: this.renewalPopUp,
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'NO',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'SI'
    }).then((result) => {
      if (result.isDenied || result.isDismissed) {
        Swal.fire(
          'Renovación de licencias',
          'No es posible continuar con el trámite, ya que no pertenece a Bogotá',
          'error'
        );
        this.ocultarRenovacionBogota = true;
      } else {
        this.showModificationForm = false;
        this.showRenewalForm = true;
        this.ocultarRenovacionBogota = false;
      }
    });
  }

  getErrorMessage(field: string): string {
    let message;
    if(this.isTouchedField(this.requestForm, field))
    {
      if(this.requestForm?.get(field).hasError('required'))
      {
        message = 'Es requerido';
      }
      else if(this.requestForm?.get(field).hasError('maxlength'))
      {
        message = `Permite hasta `+this.requestForm?.get(field).errors.maxlength.requiredLength+` caracteres`;
      }
      else if(this.requestForm?.get(field).hasError('minlength'))
      {
        message = `Permite hasta `+this.requestForm?.get(field).errors.minlength.requiredLength+` caracteres`;
      }
    }

    return message;
  }


  cancelFrm() {
    this.router.navigateByUrl(ROUTES.PERSON_DASHBOARD);
  }



  async saveRequest() {
    const formData = this.requestForm.value;
    const personTypeId: number = this.showFormPersonaJuridica ? 2 : 1; // si el usuario es juridica o ntural -> modificar posteriormente
    const procedureType = this.requestForm.get('processId').value;
    const laborFrm = formData['laborForm'];
    const typeServiceFrm = formData['typeServiceForm'];
    const attachmentForm = formData['attachmentForm'];
    const modificationForm = formData['modificationForm'];
    const renewalForm = formData['renewalForm'];
    let requestToSave = { ...laborFrm, ...typeServiceFrm, ...attachmentForm, licenseToModifyPath: null, personTypeId };

    // modificacion
    if (procedureType == 2) requestToSave = { ...requestToSave, ...modificationForm }
    // renovacion
    if (procedureType == 3) requestToSave = { ...requestToSave, ...renewalForm }



    if (!this.requestForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, hay datos invalidos y/o incompletos.`,
        4000
      );
      console.log("FORMULARIO PROCESADO");
      console.log(this.requestForm.value);
      console.log("ERRORES FORMULARIO");
      console.log(super.getAllErrors(this.requestForm));
      this.requestForm.markAllAsTouched();
      return;
    }

    if (this.files.length == 0) {
      this.popupAlert.errorAlert(
        'No se encontraron archivos adjuntos, ¡revise por favor!',
        4000);
      return;
    }

    let cantidadDocumentos = attachmentForm.quantityDocuments;

    console.log("files lenght", this.files.length);
    console.log("cantidadDocumentos", cantidadDocumentos);

    if (this.files.length < cantidadDocumentos) {
      this.popupAlert.errorAlert(
        'Hay requisitos sin documentos adjuntos, ¡revise por favor!',
        4000);
      return;
    }

    delete requestToSave.quantityDocuments;

    this.sending = true;
    requestToSave = {
      ...requestToSave,
      statusId: 1,
      processId: this.requestForm.get('processId').value, // 1=> PRIMERA VEZ, 2 => MODIFICACION, 3=> RENOVACION
      documentSuppors: []
    };

    this.popupAlert.infoAlert(
      `<b>Guardando...</b> Puede tardar un poco, no actualice o recarge la página, un momento por favor`,
      4000
    );

    for (const newFile of this.files) {
      const fmData = new FormData();
      fmData.append('File', newFile.contenido);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: newFile.docTypeId,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
        }).catch(err => {
          console.error('Error al adjuntar documento: ' + newFile.docTypeId);
        });
    }

    if (procedureType == 2 && requestToSave.licenciaVigenteFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.licenciaVigenteFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 13,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.file;
          delete requestToSave.licenciaVigenteFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia vigente', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.licenciaVigenteFile?.name);
        });
    }

    if (procedureType == 2 && requestToSave.soporteModificacionFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.soporteModificacionFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 15,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.fileSoporte;
          delete requestToSave.soporteModificacionFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia vigente', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.soporteModificacionFile?.name);
        });
    }

    if (procedureType == 3 && requestToSave.licenciaAnteriorFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.licenciaAnteriorFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 14,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.file;
          delete requestToSave.licenciaAnteriorFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia anterior', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.licenciaAnteriorFile?.name);
        });
    }


    this.procedureService.saveProcedureRequest(requestToSave)
      .subscribe({
        next: resp => {
          this.sending = false;
          this.popupAlert.successAlert(
            'Su solicitud se ha registrado satisfactoriamente!',
            4000);
          console.log("TRAMITE PROCESADO")
          console.log(requestToSave)
          this.goTop();
          this.requestForm.reset();
          this.ocultarRenovacionBogota = true;
          this.numRadicado = resp.consecutivo;
          console.log("RESP NUmero radicado", resp.consecutivo)
          this.finishProcedure(this.numRadicado);
          console.log(this.numRadicado)
        },
        error: err => {
          this.sending = false;
          this.popupAlert.errorAlert(
            'Ocurrió un error al guardar la solicitud',
            4000);
          console.log("ERROR")
          console.log(err)
          console.log("TRAMITE NO PROCESADOR")
          console.log(requestToSave)
        }
      });
  }

  finishProcedure(numeroRadicado): void {
    this.sendEmail(numeroRadicado);
    this.showReqForm = false;
    this.showResumeRequestSaved = true;
    this.step = 3;
    this.currentStep = 80;
  }

  sendEmail(numeroRadicado): void {
    let emailPersona = this.authService.getLoggedUser().emails[0];
    let tituloEmail = "Radicación trámite Licencia de Seguridad y Salud en el Trabajo – SDS";
    let bodyEmail = this.cuerpoEmail(this.authService.getLoggedUser().name, numeroRadicado);


    let cuerpoEmail = {
      "to": emailPersona,
      "subject": tituloEmail,
      "body": bodyEmail
    }

    this.registrationService.sendEmail(cuerpoEmail).subscribe(resp => {
      console.log("YA ENVIÉ EL CORREO");
      this.popupAlert.successAlert("Notificación enviada al ciudadano.", 3000);
    });
  }

  cuerpoEmail(fullName, numeroRadicado) {
    return "Respetado(a) Ciudadano(a), " + fullName + "<br>" +
      "<br>" +
      "¡Su trámite se ha radicado correctamente! " + "<b>Número radicado: " + numeroRadicado + "</b>" +
      "<br>" + "<br>" +
      "Recuerde que, ingresando al enlace <a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> con su usuario y clave de ingreso puede consultar el estado de su trámite, en la opción “Mis trámites”, posteriormente “Mis Tramites de Seguridad y Salud en el Trabajo”" +
      "<br>" + "<br>" +
      "Ante cualquier inquietud puede consultar la información dispuesta en el portal de la Ventanilla Única de Trámites y Servicios o a través del correo contactenos@saludcapital.gov.co <br>" +
      "<br>" +
      "Cordialmente,<br>" +
      "<br>" +
      "SECRETARIA DISTRITAL DE SALUD<br>" +
      "<a href='https://lemon-smoke-06942be0f-dev.eastus2.2.azurestaticapps.net'> Tramites</a> <br>" +
      "KR 32 No. 12 - 81<br>" +
      "Teléfono (601)3649090<br>" +
      "<img src='https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.colnodo.apc.org%2Fes%2Forganizaciones-aliadas%2Fsecretaria-distrital-de-salud&psig=AOvVaw3nV8X82K0RbU_RliXnBHdI&ust=1674671289741000&source=images&cd=vfe&ved=0CBAQjRxqFwoTCJD6-e7q4PwCFQAAAAAdAAAAABAD'>"

  }



  setOrRemoveValidatorsInModify(action: number = 1) {
    if (action == 1) {
      this.requestForm.get('modificationForm.reasonModificationId').setValidators([Validators.required]);
      this.requestForm.get('modificationForm.reasonModificationId').updateValueAndValidity();

      this.requestForm.get('modificationForm.resolutionToModify').setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
      this.requestForm.get('modificationForm.resolutionToModify').updateValueAndValidity();

      this.requestForm.get('modificationForm.dateResolutionToModify').setValidators([Validators.required, super.dateValidator]);
      this.requestForm.get('modificationForm.dateResolutionToModify').updateValueAndValidity();

      this.requestForm.get('modificationForm.licenciaVigenteFile').setValidators([Validators.required]);
      this.requestForm.get('modificationForm.licenciaVigenteFile').updateValueAndValidity();

      if (this.showFormPersonaJuridica) {
        this.requestForm.get('modificationForm.soporteModificacionFile').setValidators([Validators.required]);
        this.requestForm.get('modificationForm.soporteModificacionFile').updateValueAndValidity();
      }

    } else {
      this.requestForm.get('modificationForm.reasonModificationId').clearValidators();
      this.requestForm.get('modificationForm.reasonModificationId').setErrors(null);
      this.requestForm.get('modificationForm.reasonModificationId').updateValueAndValidity();

      this.requestForm.get('modificationForm.resolutionToModify').clearValidators();
      this.requestForm.get('modificationForm.resolutionToModify').setErrors(null);
      this.requestForm.get('modificationForm.resolutionToModify').updateValueAndValidity();

      this.requestForm.get('modificationForm.dateResolutionToModify').clearValidators();
      this.requestForm.get('modificationForm.dateResolutionToModify').setErrors(null);
      this.requestForm.get('modificationForm.dateResolutionToModify').updateValueAndValidity();

      this.requestForm.get('modificationForm.licenciaVigenteFile').clearValidators();
      this.requestForm.get('modificationForm.licenciaVigenteFile').setErrors(null);
      this.requestForm.get('modificationForm.licenciaVigenteFile').updateValueAndValidity();

      this.requestForm.get('modificationForm.soporteModificacionFile').clearValidators();
      this.requestForm.get('modificationForm.soporteModificacionFile').setErrors(null);
      this.requestForm.get('modificationForm.soporteModificacionFile').updateValueAndValidity();

      this.requestForm.get('modificationForm').reset();
    }
  }

  setOrRemoveValidatorsInRenew(action: number = 1) {
    if (action == 1) {
      this.requestForm.get('renewalForm.renovationDepartmentId').setValidators([Validators.required]);
      this.requestForm.get('renewalForm.renovationDepartmentId').updateValueAndValidity();

      this.requestForm.get('renewalForm.renovationMunicipalityId').setValidators([Validators.required]);
      this.requestForm.get('renewalForm.renovationMunicipalityId').updateValueAndValidity();

      this.requestForm.get('renewalForm.resolutionToModify').setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
      this.requestForm.get('renewalForm.resolutionToModify').updateValueAndValidity();

      this.requestForm.get('renewalForm.dateResolutionToModify').setValidators([Validators.required, super.dateValidator]);
      this.requestForm.get('renewalForm.dateResolutionToModify').updateValueAndValidity();

      this.requestForm.get('renewalForm.licenciaAnteriorFile').setValidators([Validators.required]);
      this.requestForm.get('renewalForm.licenciaAnteriorFile').updateValueAndValidity();

    } else {
      this.requestForm.get('renewalForm.renovationDepartmentId').clearValidators();
      this.requestForm.get('renewalForm.renovationDepartmentId').setErrors(null);
      this.requestForm.get('renewalForm.renovationDepartmentId').updateValueAndValidity();

      this.requestForm.get('renewalForm.renovationMunicipalityId').clearValidators();
      this.requestForm.get('renewalForm.renovationMunicipalityId').setErrors(null);
      this.requestForm.get('renewalForm.renovationMunicipalityId').updateValueAndValidity();

      this.requestForm.get('renewalForm.resolutionToModify').clearValidators();
      this.requestForm.get('renewalForm.resolutionToModify').setErrors(null);
      this.requestForm.get('renewalForm.resolutionToModify').updateValueAndValidity();

      this.requestForm.get('renewalForm.dateResolutionToModify').clearValidators();
      this.requestForm.get('renewalForm.dateResolutionToModify').setErrors(null);
      this.requestForm.get('renewalForm.dateResolutionToModify').updateValueAndValidity();

      this.requestForm.get('renewalForm.licenciaAnteriorFile').clearValidators();
      this.requestForm.get('renewalForm.licenciaAnteriorFile').setErrors(null);
      this.requestForm.get('renewalForm.licenciaAnteriorFile').updateValueAndValidity();
      this.requestForm.get('renewalForm').reset();
    }
  }

  setOrRemoveValidatorsIfWorking(action: number = 1) {
    if (action == 1) {

      this.requestForm.get('laborForm.companyWorking').setValidators([Validators.required]);
      this.requestForm.get('laborForm.companyWorking').updateValueAndValidity();

      this.requestForm.get('laborForm.companyName').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(100)]);
      this.requestForm.get('laborForm.companyName').updateValueAndValidity();

      this.requestForm.get('laborForm.companyAddress').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(100)]);
      this.requestForm.get('laborForm.companyAddress').updateValueAndValidity();

      this.requestForm.get('laborForm.companyDepartmentId').setValidators([Validators.required]);
      this.requestForm.get('laborForm.companyDepartmentId').updateValueAndValidity();

      this.requestForm.get('laborForm.companyMunicipalityId').setValidators([Validators.required]);
      this.requestForm.get('laborForm.companyMunicipalityId').updateValueAndValidity();

      this.requestForm.get('laborForm.companyPhone').setValidators([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      this.requestForm.get('laborForm.companyPhone').updateValueAndValidity();

      this.requestForm.get('laborForm.companyCellPhone').setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      this.requestForm.get('laborForm.companyCellPhone').updateValueAndValidity();
    } else {
      this.requestForm.get('laborForm.companyName').clearValidators();
      this.requestForm.get('laborForm.companyName').setErrors(null);
      this.requestForm.get('laborForm.companyName').updateValueAndValidity();
      this.requestForm.get('laborForm.companyName').setValue('');

      this.requestForm.get('laborForm.companyAddress').clearValidators();
      this.requestForm.get('laborForm.companyAddress').setErrors(null);
      this.requestForm.get('laborForm.companyAddress').updateValueAndValidity();
      this.requestForm.get('laborForm.companyAddress').setValue('');

      this.requestForm.get('laborForm.companyDepartmentId').clearValidators();
      this.requestForm.get('laborForm.companyDepartmentId').setErrors(null);
      this.requestForm.get('laborForm.companyDepartmentId').updateValueAndValidity();
      this.requestForm.get('laborForm.companyDepartmentId').setValue(null);

      this.requestForm.get('laborForm.companyMunicipalityId').clearValidators();
      this.requestForm.get('laborForm.companyMunicipalityId').clearValidators();
      this.requestForm.get('laborForm.companyMunicipalityId').updateValueAndValidity();
      this.requestForm.get('laborForm.companyMunicipalityId').setValue(null);

      this.requestForm.get('laborForm.companyPhone').clearValidators();
      this.requestForm.get('laborForm.companyPhone').setErrors(null);
      this.requestForm.get('laborForm.companyPhone').updateValueAndValidity();
      this.requestForm.get('laborForm.companyPhone').setValue(null);

      this.requestForm.get('laborForm.companyCellPhone').clearValidators();
      this.requestForm.get('laborForm.companyCellPhone').setErrors(null);
      this.requestForm.get('laborForm.companyCellPhone').updateValueAndValidity();
      this.requestForm.get('laborForm.companyCellPhone').setValue(null);

    }
  }

  clearValidatorsAttachmentsFrm() {
    this.requestForm.get('attachmentForm.programTypeId').clearValidators();
    this.requestForm.get('attachmentForm.programTypeId').setErrors(null);
    this.requestForm.get('attachmentForm.programTypeId').updateValueAndValidity();

    this.requestForm.get('attachmentForm.titleTypeId').clearValidators();
    this.requestForm.get('attachmentForm.titleTypeId').setErrors(null);
    this.requestForm.get('attachmentForm.titleTypeId').updateValueAndValidity();

    this.requestForm.get('attachmentForm.typeProfessionalId').clearValidators();
    this.requestForm.get('attachmentForm.typeProfessionalId').setErrors(null);
    this.requestForm.get('attachmentForm.typeProfessionalId').updateValueAndValidity();

    this.requestForm.get('attachmentForm.titleProfessionalName').clearValidators();
    this.requestForm.get('attachmentForm.titleProfessionalName').setErrors(null);
    this.requestForm.get('attachmentForm.titleProfessionalName').updateValueAndValidity();

    this.requestForm.get('attachmentForm.titleDoctorateName').clearValidators();
    this.requestForm.get('attachmentForm.titleDoctorateName').setErrors(null);
    this.requestForm.get('attachmentForm.titleDoctorateName').updateValueAndValidity();

    this.requestForm.get('attachmentForm.otherProfessionalName').clearValidators();
    this.requestForm.get('attachmentForm.otherProfessionalName').setErrors(null);
    this.requestForm.get('attachmentForm.otherProfessionalName').updateValueAndValidity();
  }

  validacionesCamposPostgradoYTipoProfesional() {

    if (this.requestForm.get('attachmentForm.programTypeId').value == '1' || this.requestForm.get('attachmentForm.programTypeId').value == '3') {
      this.requestForm.get('attachmentForm.typeProfessionalId').setValidators([Validators.required]);
    } else {
      this.requestForm.get('attachmentForm.typeProfessionalId').clearValidators();
      this.requestForm.get('attachmentForm.typeProfessionalId').setErrors(null);
      this.requestForm.get('attachmentForm.typeProfessionalId').updateValueAndValidity();
      this.requestForm.get('attachmentForm.typeProfessionalId').setValue(null);
    }

    if (this.requestForm.get('attachmentForm.programTypeId').value == '3') {
      this.requestForm.get('attachmentForm.titleDoctorateName').setValidators([Validators.required, Validators.minLength(5)]);
    } else {
      this.requestForm.get('attachmentForm.titleDoctorateName').clearValidators();
      this.requestForm.get('attachmentForm.titleDoctorateName').setErrors(null);
      this.requestForm.get('attachmentForm.titleDoctorateName').updateValueAndValidity();
      this.requestForm.get('attachmentForm.titleDoctorateName').setValue(null);
    }

  }

  validacionesOtroProfesional() {
    if (this.requestForm.get('attachmentForm.typeProfessionalId').value == '4') {
      console.log("lo estoy activando")
      this.requestForm.get('attachmentForm.otherProfessionalName').setValidators([Validators.required, Validators.minLength(5)]);
    } else {
      console.log("lo estoy desactivando")
      this.requestForm.get('attachmentForm.otherProfessionalName').clearValidators();
      this.requestForm.get('attachmentForm.otherProfessionalName').setErrors(null);
      this.requestForm.get('attachmentForm.otherProfessionalName').updateValueAndValidity();
      this.requestForm.get('attachmentForm.otherProfessionalName').setValue(null);
    }
  }

  goTop() {
    let mainInter = document.getElementById('interno');
    mainInter?.scroll(0, 0);
    let main = document.getElementById('content-layout-id');
    main?.scroll(0, 0);
  }

  onExit(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log("estoy aqui")
    let exit: boolean = false;
    window.confirm("asdasdasd")


    if (this.sending) {
      Swal.fire('No puedes salir de la página ya que se está guardando el formulario.');
    } else if (this.requestForm.dirty) {
      Swal.fire({
        title: 'Salir de formulario',
        text: "No ha completado el formulario, ¿está seguro de salir de esta página?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          exit = true;
        }
      })
    }

    return exit;
  }

}
